export default "__VITE_ASSET__rJFFYh4c__"